import { client } from '../common/client';
import type { GetGeoLocationRequest, GetGeoLocationResponse } from './utils/types';

export const deviceAPIClient = {
  /**
   * Fetch geo location information by IP address
   */
  getGeoLocation: async (params: GetGeoLocationRequest): Promise<GetGeoLocationResponse> =>
    client.get('/device/getGeoLocation', { params }).then((res) => res.data),
};
